export const dictionaryTerms = [
  {
    id: 1,
    term: "PGN (Portable Game Notation):",
    explanation:
      "format zapisu partii szachowych. Jest on najpopularniejszym tego typu formatem, otwieranym przez każdy program obsługujący bazy szachowe.",
  },

  {
    id: 2,
    term: "FEN (Forsyth–Edwards Notation):",
    explanation:
      "zapis szachowy dla określenia pozycji gry szachowej. Celem FEN jest podanie wszystkich niezbędnych informacji do ponownego rozpoczęcia gry od danej pozycji.",
  },

  {
    id: 3,
    term: "UCI (Universal Chess Interface):",
    explanation:
      "otwarty protokół komunikacyjny, który umożliwia silnikom szachowym komunikację z interfejsami użytkownika.",
  },
];
